import { useState, useEffect } from "react";
import { SimplifiedBrandPreview } from "@/components/brand/SimplifiedBrandPreview";

/**
 * Standalone preview page for simplified brand preview during signup
 * This page is designed to be loaded in an iframe
 * It relies on postMessage communication from the parent window
 */
export function SimplifiedPreview() {
  // Local state for iframe communication
  const [formData, setFormData] = useState<{
    companyName: string;
    brandProfileImage?: string;
    niches: Array<{ id: string; name: string }>;
  }>({
    companyName: "",
    niches: [],
  });

  // Listen for postMessage updates from parent window
  useEffect(() => {
    const handleMessage = (event: MessageEvent) => {
      if (event.data && event.data.type === "SIGNUP_FORM_DATA_UPDATE") {
        console.log("SimplifiedPreview received data:", event.data.formData);
        setFormData(event.data.formData);
      }
    };

    window.addEventListener("message", handleMessage);

    // Request initial data from parent
    if (window.parent !== window) {
      window.parent.postMessage({ type: "REQUEST_INITIAL_DATA" }, "*");
    }

    return () => window.removeEventListener("message", handleMessage);
  }, []);

  return (
    <div style={{ minHeight: "100vh", width: "100%" }}>
      <SimplifiedBrandPreview
        companyName={formData.companyName}
        brandProfileImage={formData.brandProfileImage}
        niches={formData.niches}
      />
    </div>
  );
}
